(function () {
  var YOTPO_FLOATER_SELECTOR = '.yotpo-widget-loyalty-floater-widget';
  var YOTPO_BANNER_SELECTOR = '.yotpo-banner-layout';
  var YOTPO_DRAWER_ID = 'yotpo-drawer-layout';
  var OPEN_CLASS = 'is-open-via-sticky-cart';

  function getYotpoBanner() {
    return (
      document.querySelector('.yotpo-is-mobile ' + YOTPO_BANNER_SELECTOR) ||
      document.querySelector(YOTPO_BANNER_SELECTOR)
    );
  }

  function isYotpoDrawerOpen(banner, drawer) {
    var expandedByAria = banner && banner.getAttribute('aria-expanded') === 'true';
    var expandedByStyle = drawer && drawer.style.display && drawer.style.display !== 'none';
    return Boolean(expandedByAria || expandedByStyle);
  }

  function watchYotpoOpenState() {
    var yotpoFloater = document.querySelector(YOTPO_FLOATER_SELECTOR);
    var yotpoBanner = getYotpoBanner();
    var yotpoDrawer = document.getElementById(YOTPO_DRAWER_ID);
    if (!yotpoFloater || !yotpoBanner) return false;

    function sync() {
      var open = isYotpoDrawerOpen(yotpoBanner, yotpoDrawer);
      yotpoFloater.classList.toggle(OPEN_CLASS, open);
    }

    sync();

    var observer = new MutationObserver(sync);
    observer.observe(yotpoBanner, { attributes: true, attributeFilter: ['aria-expanded'] });
    if (yotpoDrawer) {
      observer.observe(yotpoDrawer, { attributes: true, attributeFilter: ['style'] });
    }

    return true;
  }

  function initAddToCart(stickyBar) {
    var stickySubmit = stickyBar.querySelector('[data-sticky-add-to-cart-submit]');
    if (!stickySubmit) return;

    var realForm = document.getElementById(stickyBar.dataset.formId);
    var realSubmitButton = document.querySelector('.product-submit-button');
    var realQuantityInput = document.querySelector('.quantity-counter');
    if (!realForm || !realSubmitButton || !realQuantityInput) return;

    var quantityValue = stickyBar.querySelector('[data-sticky-quantity-value]');
    var quantityDecrease = stickyBar.querySelector('[data-sticky-quantity-decrease]');
    var quantityIncrease = stickyBar.querySelector('[data-sticky-quantity-increase]');

    function syncQuantityDisplay() {
      quantityValue.textContent = realQuantityInput.value;
    }

    function setRealQuantity(value) {
      var min = parseInt(realQuantityInput.min, 10) || 1;
      var next = Math.max(min, value);
      realQuantityInput.value = next;
      realQuantityInput.dispatchEvent(new Event('change', { bubbles: true }));
      syncQuantityDisplay();
    }

    quantityDecrease.addEventListener('click', function () {
      setRealQuantity(parseInt(realQuantityInput.value, 10) - 1);
    });

    quantityIncrease.addEventListener('click', function () {
      setRealQuantity(parseInt(realQuantityInput.value, 10) + 1);
    });

    realQuantityInput.addEventListener('change', syncQuantityDisplay);
    realQuantityInput.addEventListener('input', syncQuantityDisplay);
    syncQuantityDisplay();

    stickySubmit.addEventListener('click', function () {
      realSubmitButton.click();
    });
  }

  function setBisLoading(container, isLoading) {
    var submitButton = container.querySelector('[data-sticky-bis-submit]');
    var spinner = submitButton.querySelector('.loading__spinner');
    submitButton.disabled = isLoading;
    submitButton.classList.toggle('loading', isLoading);
    if (spinner) spinner.classList.toggle('hidden', !isLoading);
  }

  function showBisState(container, state) {
    var form = container.querySelector('[data-sticky-bis-form]');
    var success = container.querySelector('[data-sticky-bis-success]');
    var error = container.querySelector('[data-sticky-bis-error]');
    form.classList.add('hidden');
    success.classList.add('hidden');
    error.classList.add('hidden');
    if (state === 'success') success.classList.remove('hidden');
    if (state === 'error') error.classList.remove('hidden');
  }

  function initBis(stickyBar) {
    var container = stickyBar.querySelector('[data-sticky-bis]');
    if (!container) return;

    var trigger = container.querySelector('[data-sticky-bis-trigger]');
    var form = container.querySelector('[data-sticky-bis-form]');

    trigger.addEventListener('click', function () {
      trigger.classList.add('hidden');
      form.classList.remove('hidden');
      container.querySelector('[data-sticky-bis-email]').focus();
    });

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      var variantId = container.getAttribute('data-variant-id');
      var email = container.querySelector('[data-sticky-bis-email]').value;

      setBisLoading(container, true);

      window.KlaviyoBisApi.subscribe(variantId, email)
        .then(function () {
          setBisLoading(container, false);
          showBisState(container, 'success');
        })
        .catch(function (error) {
          setBisLoading(container, false);
          console.error(error);
          showBisState(container, 'error');
        });
    });
  }

  function init() {
    var stickyBar = document.querySelector('[data-sticky-add-to-cart]');
    if (!stickyBar) return;

    initAddToCart(stickyBar);
    initBis(stickyBar);

    var rewardsChip = stickyBar.querySelector('[data-sticky-rewards-chip]');
    if (rewardsChip) {
      rewardsChip.addEventListener('click', function () {
        var yotpoBanner = getYotpoBanner();
        if (yotpoBanner) yotpoBanner.click();
      });
    }

    if (!watchYotpoOpenState()) {
      var pageObserver = new MutationObserver(function () {
        if (watchYotpoOpenState()) pageObserver.disconnect();
      });
      pageObserver.observe(document.documentElement, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
